<!-- <div class="login">
  <form class="custom-form" method="post">
    <h1>Login</h1>

    <input
      type="email"
      name="email"
      placeholder="Email"
      required="required"
    />
    <input
      type="password"
      name="password"
      placeholder="Password"
      required="required"
    />
    <button type="submit" (click)="login()">Log in</button>
  </form>
</div> 
==================================================================================================================== -->

<div class="main-wrapper">

  <div class="login-wrapper">

    <div class="header">
      <div class="header-logo"><img src="../../../assets//img/login_logo.png"></div>
      <div class="header-language-selectors">
        <div (click)="changeLang('es')"><img style="margin-right: 8px" src="../../../assets/img/flags/es_black.png">
        </div>
        <div (click)="changeLang('cat')"><img style="margin-right: 8px" src="../../../assets/img/flags/cat_black.png">
        </div>
        <div (click)="changeLang('en')"><img src="../../../assets/img/flags/en_black.png"></div>
      </div>
    </div>

    

    <div class="login-form" [formGroup]="loginForm">

      <mat-form-field appearance="outline">
        <input matInput placeholder="{{ 'login.user' | translate }}" type="email" [formControlName]="'user'">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <input type="password" matInput placeholder="{{ 'login.password' | translate }}" [formControlName]="'password'">
      </mat-form-field>

      <div class="reset-password-button">
        <span (click)="resetPassword()">{{ 'login.forgot_password' | translate }}</span>
      </div>

    </div>

    <div class="login-actions">
      <div class="login-button-wrapper">
        <button mat-flat-button class="login-button " (click)="login()"><span style="text-transform: uppercase">{{
            'login.log_in' | translate }}</span></button>
      </div>
      <div class="action-button-wrapper">
        <button mat-flat-button class="action-button" (click)="redirectToWeb()">
          <mat-icon>keyboard_arrow_left</mat-icon> {{ 'login.go_back_to_web' | translate }}
        </button>
        <button mat-flat-button class="action-button" (click)="logWithGoogle()">
          {{ 'login.google' | translate }}
        </button>
      </div>
      <div class="login-button-wrapper" style="margin-top: 16px;">
        <button mat-flat-button class="register-button" (click)="resetPassword()"><span
            style="text-transform: uppercase">{{
            'login.first_time_access' | translate }}</span></button>
      </div>
      <div class="login-button-wrapper" style="margin-top: 0px;">
        <button mat-flat-button class="register-button" routerLink="/new-account"><span
            style="text-transform: uppercase">{{
            'login.create_account' | translate }}</span></button>
      </div>
      <div class="login-content">
        <p>{{ 'login.intro_paragraph' | translate }}</p>
        <p style="font-weight: 600; font-size: 14px;">{{ 'login.intro_warning' | translate }}</p>
      </div>
    </div>


    <!-- <div class="login-footer">
      <div class="login-button-wrapper">
        <button mat-flat-button class="login-button " (click)="login()"><span style="text-transform: uppercase">{{
            'login.log_in' | translate }}</span></button>
      </div>
    </div> -->

  </div>

</div>

<!-- <div class="login-wrapper" fxLayout="row" fxLayoutAlign="center center">


  <mat-card class="login-form">

    <mat-card-header>
      <ul fxLayout="row" fxLayoutGap="5px">
        <div style="width: 100%;">
          <img class="login-logo" src="../../../assets/img/login_logo.png" />

        </div>


        <button mat-menu-item fxLayoutAlign="left center" id="idioma" (click)="changeLang('es')" mat-menu-item><img
            id="idioma" src="../../../assets/img/flags/es_black.png"></button>
        <button mat-menu-item fxLayoutAlign="left center" id="idioma" (click)="changeLang('cat')" mat-menu-item><img
            id="idioma" src="../../../assets/img/flags/cat_black.png"></button>
        <button mat-menu-item fxLayoutAlign="left center" id="idioma" (click)="changeLang('en')" mat-menu-item><img
            id="idioma" src="../../../assets/img/flags/en_black.png"></button>


      </ul>

    </mat-card-header>

    <form class="example-form" [formGroup]="loginForm">
      <mat-card-content>
        <mat-form-field class="example-full-width">
          <input matInput placeholder="{{ 'login.user' | translate }}" type="email" [formControlName]="'user'">
        </mat-form-field>

        <mat-form-field class="example-full-width">
          <input type="password" matInput placeholder="{{ 'login.password' | translate }}"
            [formControlName]="'password'">
        </mat-form-field>
      </mat-card-content>
      <button mat-stroked-button color="primary" class="btn-block" (click)="login()">{{ 'login.log_in' | translate
        }}</button>
    </form>
    <button class="loginWithGoogle" (click)="authService.GoogleAuth()" mat-button>{{ 'login.google' | translate
      }}</button>
    <button class="resetPassword" (click)="resetPassword()" mat-button>{{ 'login.reset' | translate }}</button>
  </mat-card>

</div> -->



<!-- ============================================================================================================

<mat-card class="login-form">
    <form [formGroup]="loginForm">
        <mat-form-field>
            <input matInput placeholder="Usuario" [formControlName]="'user'">
        </mat-form-field>
        <br/>
        <mat-form-field>
            <input type="password" matInput placeholder="Password" [formControlName]="'password'">
        </mat-form-field>
    </form>
    <button mat-button (click)="login()">Entrar</button>
  <button (click)="logWithGoogle()" mat-button>Entrar con tu cuenta de Google</button> 
  </mat-card>
   -->